import R from 'app/assets/R'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { useModalHook } from './hook'
import { IPropsDeleteSkill } from './type'
import { BaseCol } from 'app/components/common/BaseCol'
import * as S from './styles'

export const Delete = (props: IPropsDeleteSkill) => {
  const { visible, isLoading, showModal, handleCancel, handleSubmit, t } =
    useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="delete"
      titleKeyI18n={R.strings.delete}
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.delete}
      confirmKeyI18n={R.strings.delete}
      handleSubmit={handleSubmit}
      visible={visible}
      widthModal={500}
      descriptionDelete={
        <>
          <BaseCol>
            <span>
              {t(R.strings.skill_content_are_you_want_delete)}{' '}
              <S.TextSkill>{props?.name ?? ''}</S.TextSkill>
            </span>
          </BaseCol>
          <BaseCol>
            {t(
              R.strings
                .skill_content_once_the_skill_is_locked_it_cannot_be_recovered,
            )}
          </BaseCol>
        </>
      }
    />
  )
}
